import { getAxiosClient } from "../../axios-client";
import { WarehousesInsuranceUpdateBody, WarehousesInsuranceUpdateResponse } from "./types";

const axiosClient = getAxiosClient();
export const updateWarehousesInsurance = async (body: WarehousesInsuranceUpdateBody) => {
    return await axiosClient.ax
    .put<WarehousesInsuranceUpdateResponse>("/WarehousesInsurance/Update", body,{headers: {'content-type': 'multipart/form-data'}})
  };
  